import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../../lib/auth'

export const ProtectedRoute = ({ children }: any) => {
  const user = useAuth()
  const location = useLocation()

  if (!user?.user) {
    // Redireciona para login sem manter o estado se já estiver na página de login
    // ou se a localização atual for inválida
    const shouldPreserveState =
      location.pathname !== '/login' && location.pathname !== '/'
    return (
      <Navigate
        to="/login"
        state={shouldPreserveState ? { from: location } : undefined}
        replace
      />
    )
  }

  return children || <Outlet />
}
